import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const RELIGIONS = ['Islam', 'Buddhism', 'Christianity', 'Hinduism', 'Sikhism', 'Taoism', 'Other', 'Prefer not to say'];
export const QUALIFICATION_LEVELS = ['SPM / O-Level', 'STPM / A-Level / Pre-U', 'Certificate', 'Diploma', 'Advanced Diploma', "Bachelor's Degree", "Master's Degree", 'Doctorate (PhD)', 'Professional Qualification', 'Other'];

const selectCls = 'w-full h-10 rounded-md border border-slate-300 dark:border-slate-600 px-3 bg-white dark:bg-slate-900 dark:text-slate-100';
const inputCls = 'dark:bg-slate-900 dark:border-slate-600';

// Passport (non-Malaysians), religion and highest qualification — shared by Add & Edit employee forms.
export function PersonalExtrasFields({ form, onChange }) {
  const isForeign = form.nationality && form.nationality !== 'malaysian';
  const q = form.highest_qualification || {};
  const setQ = (patch) => onChange({ highest_qualification: { ...q, ...patch } });
  return (
    <>
      {isForeign && (
        <>
          <div>
            <Label>Passport No. *</Label>
            <Input required value={form.passport_number || ''} onChange={(e) => onChange({ passport_number: e.target.value })}
              placeholder="A12345678" data-testid="emp-passport-input" className={`${inputCls} border-amber-300`} />
            <p className="text-xs text-amber-600 mt-1">Required for non-Malaysian employees</p>
          </div>
          <div>
            <Label>Passport Expiry</Label>
            <Input type="date" value={form.passport_expiry || ''} onChange={(e) => onChange({ passport_expiry: e.target.value })}
              data-testid="emp-passport-expiry-input" className={inputCls} />
          </div>
          <div>
            <Label>Visa / Work Permit Reference *</Label>
            <Input required value={form.visa_reference || ''} onChange={(e) => onChange({ visa_reference: e.target.value })}
              placeholder="e.g. WP-12345678" data-testid="emp-visa-reference-input" className={`${inputCls} border-amber-300`} />
            <p className="text-xs text-amber-600 mt-1">Required for non-Malaysian employees</p>
          </div>
          <div>
            <Label>Visa / Permit Expiry</Label>
            <Input type="date" value={form.visa_expiry || ''} onChange={(e) => onChange({ visa_expiry: e.target.value })}
              data-testid="emp-visa-expiry-input" className={inputCls} />
          </div>
        </>
      )}
      <div>
        <Label>Religion</Label>
        <select value={form.religion || ''} onChange={(e) => onChange({ religion: e.target.value })} data-testid="emp-religion-select" className={selectCls}>
          <option value="">Select…</option>
          {RELIGIONS.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>
      <div>
        <Label>Highest Qualification</Label>
        <select value={q.level || ''} onChange={(e) => setQ({ level: e.target.value })} data-testid="emp-qualification-level-select" className={selectCls}>
          <option value="">Select level…</option>
          {QUALIFICATION_LEVELS.map((l) => <option key={l} value={l}>{l}</option>)}
        </select>
      </div>
      <div>
        <Label>Field of Study</Label>
        <Input value={q.field_of_study || ''} onChange={(e) => setQ({ field_of_study: e.target.value })} placeholder="e.g. Accounting" data-testid="emp-qualification-field-input" className={inputCls} />
      </div>
      <div>
        <Label>Institution</Label>
        <Input value={q.institution || ''} onChange={(e) => setQ({ institution: e.target.value })} placeholder="e.g. Universiti Malaya" data-testid="emp-qualification-institution-input" className={inputCls} />
      </div>
      <div>
        <Label>Year Completed</Label>
        <Input type="number" min="1950" max="2100" value={q.year_completed || ''} onChange={(e) => setQ({ year_completed: e.target.value })} placeholder="2018" data-testid="emp-qualification-year-input" className={inputCls} />
      </div>
    </>
  );
}
